import type { IdTokenUserClaim } from '@side/next-auth';
import type { IdentityUser, UserInformation } from '../types/user';
import { getFullName } from './person';

export function getUserInformation(
  data: IdentityUser | IdTokenUserClaim,
): UserInformation {
  let email: string | undefined;
  if ('contacts' in data) {
    email = data.contacts.find((c) => c.type === 'EMAIL' && c.primary)?.value;
  } else {
    email = data.email ?? data.loginEmail;
  }
  return {
    id: data.id,
    firstName: data.firstName,
    lastName: data.lastName,
    displayName: data.displayName ?? getFullName(data.firstName, data.lastName),
    email: email ?? '',
    photoUrl: data.photoUrl ?? null,
    roles: data.roles,
  };
}
